/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import PhCheckCircle from 'ember-phosphor-icons/components/ph-check-circle';
import PhXCircle from 'ember-phosphor-icons/components/ph-x-circle';
import {
  SafeguestVerificationStatus,
  type ISafeguestVerification,
} from 'uplisting-frontend/models/booking';

interface IArgs {
  safeguestVerification: ISafeguestVerification;
}

interface BookingStatusSafeguestVerificationSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

export default class UiBookingStatusSafeguestVerificationComponent extends Component<BookingStatusSafeguestVerificationSignature> {
  @cached
  get safeguestVerification(): ISafeguestVerification {
    return this.args.safeguestVerification;
  }

  @cached
  get statusKey(): string {
    // Convert enum value to translation key (they use the same snake_case format)
    return this.safeguestVerification.status;
  }

  @cached
  get alertClass():
    | 'inline-alert-danger'
    | 'inline-alert-success'
    | 'inline-alert-warning'
    | 'inline-alert-processing' {
    switch (this.safeguestVerification.status) {
      case SafeguestVerificationStatus.pending:
        return 'inline-alert-processing';
      case SafeguestVerificationStatus.red:
        return 'inline-alert-danger';
      case SafeguestVerificationStatus.green:
        return 'inline-alert-success';
      case SafeguestVerificationStatus.yellow:
        return 'inline-alert-warning';
    }
  }

  @cached
  get iconComponent(): typeof PhXCircle | typeof PhCheckCircle | undefined {
    switch (this.safeguestVerification.status) {
      case SafeguestVerificationStatus.pending:
        return PhXCircle;
      case SafeguestVerificationStatus.green:
      case SafeguestVerificationStatus.yellow:
      case SafeguestVerificationStatus.red:
        return PhCheckCircle;
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Booking::Status::SafeguestVerification': typeof UiBookingStatusSafeguestVerificationComponent;
  }
}
